import { format, isDate } from 'date-fns';

export const parseObjectToSearchParams = <
  T extends object = Record<string, string | object | boolean | undefined>,
>(
  args: T
): T =>
  Object.entries(args).reduce((acc, [key, value]) => {
    acc[key as keyof T] = Array.isArray(value)
      ? value.filter((val) => val.trim().length).join(',')
      : isDate(value)
        ? format(value, 'yyyy-MM-dd')
        : typeof value === 'object'
          ? Object.values(value).join('').trim().length
            ? parseObjectToSearchParams(value)
            : undefined
          : typeof value === 'boolean'
            ? value.toString() === 'true'
              ? value
              : undefined
            : value?.length
              ? value
              : undefined;
    return acc;
  }, {} as T);
